import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { ShellContext } from './layout/AppShell';
import PageShell from './layout/PageShell';
import { EmptyState, SectionCard } from './ui';

/**
 * Pages only administrators use (products, stock, promotions, loyalty, the team, the brand, the activity log): anyone
 * else on the team sees why instead of a page whose every change the server would refuse.
 */
const AdminOnly = ({ children }: { children: React.ReactElement }) => {
  const { membership } = React.useContext(ShellContext);
  const navigate = useNavigate();
  if (!membership || membership.is_admin) return children;
  return (
    <PageShell title="Solo para administradores">
      <SectionCard>
        <EmptyState icon={<LockOutlinedIcon />} title="Esta sección es para los administradores de tu negocio"
          description="Ellos cambian productos, inventario, promociones y al equipo. Si necesitas hacerlo, pídele al dueño que te haga administrador."
          action={<Button variant="contained" onClick={() => navigate('/admin')}>Ir al inicio</Button>} />
      </SectionCard>
    </PageShell>
  );
};

export default AdminOnly;
